<template>
	<div class="invoice-page">

		<!-- 发票信息区块 -->
		<div class="member-card">
			<div class="card-header">
				<div>
					<div class="card-title">我的发票信息</div>
					<div class="card-desc">企业开票信息，下单后可快速申请开具发票</div>
				</div>
				<el-button type="primary" size="small" icon="el-icon-plus" @click="addInfo">添加发票信息</el-button>
			</div>

			<!-- 发票卡片网格 -->
			<div v-loading="loading" element-loading-text="加载中...">
				<div class="invo-grid" v-if="list.length">
					<div
						class="invo-card"
						v-for="cinfo in list"
						:key="cinfo.id"
					>
					<!-- :class="{ 'is-default': cinfo.isDefault }" -->
						<!-- 卡片顶部：发票抬头 + 默认标签 -->
						<div class="invo-card-top">
							<div class="invo-title-box">
								<!-- <i class="el-icon-tickets invo-icon"></i> -->
								<span class="invo-title">{{ cinfo.invoiceTitle }}</span>
							</div>
							<el-tag v-if="cinfo.isDefault" size="mini" type="danger" effect="dark">默认</el-tag>
						</div>

						<!-- 纳税人识别号 -->
						<div class="invo-field">
							<span class="field-label">税号</span>
							<span class="field-value tax-number">{{ cinfo.taxNumber }}</span>
						</div>

						<!-- 开户银行 -->
						<div class="invo-field" v-if="cinfo.bankName">
							<span class="field-label">开户行</span>
							<span class="field-value">{{ cinfo.bankName }}</span>
						</div>

						<!-- 银行账号 -->
						<div class="invo-field" v-if="cinfo.bankAccount">
							<span class="field-label">账号</span>
							<span class="field-value">{{ cinfo.bankAccount }}</span>
						</div>

						<!-- 公司地址 -->
						<div class="invo-field" v-if="cinfo.companyAddress">
							<span class="field-label">地址</span>
							<span class="field-value">{{ cinfo.companyAddress }}</span>
						</div>

						<!-- 公司电话 -->
						<div class="invo-field" v-if="cinfo.companyPhone">
							<span class="field-label">电话</span>
							<span class="field-value">{{ cinfo.companyPhone }}</span>
						</div>

						<!-- 操作按钮 -->
						<div class="invo-actions">
							<el-button type="text" size="small" @click="modifyInfo(cinfo)">修改</el-button>
							<el-divider direction="vertical" />
							<el-button v-if="!cinfo.isDefault" type="text" size="small" @click="setDefault(cinfo)">设为默认</el-button>
							<el-divider v-if="!cinfo.isDefault" direction="vertical" />
							<el-button type="text" size="small" style="color: #ef4444" @click="removeInfo(cinfo.id)">删除</el-button>
						</div>
					</div>
				</div>

				<!-- 空状态 -->
				<div class="empty-state" v-else>
					<i class="el-icon-document"></i>
					<p>暂无发票信息，点击「添加发票信息」开始添加</p>
				</div>
			</div>
		</div>

		<!-- 新增/修改发票弹窗 -->
		<DialogInvoice
			ref="DialogInvoiceRef"
			:dialogTitle="dialogTitle"
			:dialogVisible="dialogVisible"
			:form="form"
			:rules="rules"
			@addConfirmInfo="addConfirmInfo"
			@cancel="dialogVisible = false"
			@modifyConfirmInfo="modifyConfirmInfo"
		/>
	</div>
</template>

<script>
import Y from '@/utils/Y';
import DialogInvoice from '@/views/UserCenter/components/DialogInvoice.vue';
import { getCorporateGetInvoice, deleteCorporateRemoveInvoice, postCorporateUpdateInvoice, postCorporateAddInvoice, postCorporateSetDefaultInvoice } from '@/api/user/invoice';
import mtils from 'mtils';

export default {
	name: 'Invoice',
	components: { DialogInvoice },
	data() {
		const validatePhone = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('收货人手机号码不可为空'));
			}
			if (!mtils.validation.isMobile(value)) {
				return callback(new Error('收货人手机号码格式不正确'));
			}
			callback();
		};
		const validateInvoiceTitle = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('发票抬头不可为空'));
			}
			if (value.length < 5) {
				return callback(new Error('发票抬头不少于5个字符'));
			}
			callback();
		};
		const validateTaxNumber = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('纳税人识别号不可为空'));
			}
			if (value) {
				let reg = /^(\d{15}|[A-Z0-9]{18}|\d{17}[\dX])$/;
				if (!reg.test(value)) {
					return callback(new Error('纳税人识别号格式不正确'));
				}
			}
			callback();
		};
		return {
			list: [],
			loading: false,
			dialogTitle: '新增发票',
			dialogVisible: false,
			form: {
				invoiceTitle: '',
				taxNumber: '',
				bankName: '',
				bankAccount: '',
				companyAddress: '',
				companyPhone: ''
			},
			rules: {
				invoiceTitle: [{ required: true, trigger: 'blur', validator: validateInvoiceTitle }],
				taxNumber: [{ required: true, trigger: 'blur', validator: validateTaxNumber }],
				bankName: [{ message: '开户银行不可为空', trigger: 'blur' }],
				bankAccount: [{ message: '银行账号不可为空', trigger: 'blur' }],
				companyAddress: [{ message: '公司地址不可为空', trigger: 'blur' }],
				companyPhone: [{ message: '公司电话不可为空', trigger: 'blur' }]
			}
		};
	},
	created() {
		this.getCorporateGetInvoice();
	},
	methods: {
		formatterInvoiceType(type) {
			const map = { 1: '电子普通发票', 2: '纸质普通发票', 3: '增值税专用发票' };
			return map[type] || '';
		},

		formatterTitleType(type) {
			const map = { 1: '个人', 2: '企业' };
			return map[type] || '';
		},

		// 获取发票列表
		async getCorporateGetInvoice() {
			this.loading = true;
			const res = await getCorporateGetInvoice({});
			this.list = res.data.rows;
			this.loading = false;
		},

		// 添加发票
		addInfo() {
			this.form = { invoiceType: 1, titleType: 1 };
			this.dialogTitle = '新增发票';
			this.dialogVisible = true;
		},

		// 编辑发票
		modifyInfo(item) {
			this.form = { ...item };
			this.dialogTitle = '修改发票';
			this.dialogVisible = true;
		},

		// 确认添加发票
		addConfirmInfo(val) {
			postCorporateAddInvoice(val)
				.then(() => {
					Y.msg.success('发票保存成功！');
					this.dialogVisible = false;
					this.getCorporateGetInvoice();
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		// 确认修改发票
		modifyConfirmInfo(val) {
			postCorporateUpdateInvoice(val)
				.then(() => {
					Y.msg.success('发票修改成功！');
					this.dialogVisible = false;
					this.getCorporateGetInvoice();
				})
				.catch(err => {
					Y.msg.error(err.message);
				});
		},

		// 删除发票
		removeInfo(id) {
			Y.confirm('确认删除此发票吗？').then(rlt => {
				if (rlt.confirm) {
					deleteCorporateRemoveInvoice(id)
						.then(() => {
							Y.msg.success('发票删除成功！');
							this.getCorporateGetInvoice();
						})
						.catch(err => {
							Y.msg.error(err.message);
						});
				}
			});
		},

		setDefault(item) {

			Y.confirm('确认修改默认发票吗？').then(rlt => {

				if (rlt.confirm) {
						Y.msg.success('恭喜！修改成功');
						postCorporateSetDefaultInvoice(item.id)
				.then(() => {
							Y.msg.success('默认发票修改成功！');
							this.getCorporateGetInvoice();
					})
				.catch(err => {
							Y.msg.error(err.message);
					});

				}

			});

		}
	}
};
</script>

<style lang="less" scoped>
.invoice-page {
	padding: 0;
	margin-left: 20px;
}

/* ========== 外层卡片 ========== */
.member-card {
	background: #fff;
	border-radius: 12px;
	border: 1px solid #e2e8f0;
	padding: 24px 28px;
	margin-bottom: 16px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

/* ========== 卡片头 ========== */
.card-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin-bottom: 24px;
	padding-bottom: 20px;
	border-bottom: 1px dashed #e2e8f0;
}

.card-title {
	font-size: 16px;
	font-weight: 600;
	color: #0f172a;
	margin-bottom: 6px;
}

.card-desc {
	font-size: 13px;
	color: #94a3b8;
	line-height: 1.6;
}

/* ========== 发票卡片网格 ========== */
.invo-grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;
}

/* ========== 单张发票卡片 ========== */
.invo-card {
	position: relative;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	padding: 18px 18px 14px;
	background: #fff;
	transition: border-color 0.2s, box-shadow 0.2s;

	&:hover {
		border-color: #bfdbfe;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
	}

	&.is-default {
		border-color: #ffc0c0;
		background: #fffafa;
	}
}

/* ========== 卡片顶部 ========== */
.invo-card-top {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 12px;
	padding-bottom: 10px;
	border-bottom: 1px dashed #e2e8f0;
}

.invo-title-box {
	display: flex;
	align-items: center;
	gap: 6px;
	min-width: 0;
}

.invo-icon {
	font-size: 16px;
	color: #155dfc;
	flex-shrink: 0;
}

.invo-title {
	font-size: 15px;
	font-weight: 600;
	color: #0f172a;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

/* ========== 字段行 ========== */
.invo-field {
	display: flex;
	align-items: baseline;
	gap: 8px;
	font-size: 13px;
	margin-bottom: 6px;
	line-height: 1.6;

	&:last-of-type {
		margin-bottom: 0;
	}
}

.field-label {
	color: #94a3b8;
	white-space: nowrap;
	flex-shrink: 0;
	min-width: 36px;
}

.field-value {
	color: #334155;
	word-break: break-all;
}

.tax-number {
	font-family: monospace;
	letter-spacing: 0.5px;
	color: #475569;
}

/* ========== 操作按钮 ========== */
.invo-actions {
	display: flex;
	align-items: center;
	margin-top: 12px;
	padding-top: 10px;
	border-bottom: 1px solid #f1f5f9;
}

/* ========== 空状态 ========== */
.empty-state {
	padding: 48px 0;
	text-align: center;

	i {
		font-size: 40px;
		color: #dcdfe6;
	}

	p {
		margin-top: 12px;
		font-size: 13px;
		color: #c0c4cc;
	}
}
</style>
